package com.rylcart.cp.ui.screens

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.rylcart.cp.ui.api.ApiException
import com.rylcart.cp.ui.components.PrimaryButton
import com.rylcart.cp.ui.components.TextField
import com.rylcart.cp.ui.state.LocalApp
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun LoginScreen() {
    val app = LocalApp.current
    val scope = rememberCoroutineScope()
    var email by remember { mutableStateOf("") }
    var password by remember { mutableStateOf("") }
    var busy by remember { mutableStateOf(false) }
    var firstRun by remember { mutableStateOf(false) }
    // null = still probing; true = no admin exists yet so offer registration.
    var needsSetup by remember { mutableStateOf<Boolean?>(null) }

    // Ask the server whether any admin account exists. Registration is locked
    // server-side once one does, so we only surface the first-run toggle while
    // setup is genuinely pending.
    LaunchedEffect(Unit) {
        val pending = runCatching { app.api.setupStatus().needsSetup }.getOrDefault(false)
        needsSetup = pending
        if (pending) firstRun = true
    }

    Div(attrs = { classes("login-shell") }) {
        Div(attrs = { classes("login-card") }) {
            H1 { Text("RylCart"); Span(attrs = { classes("dot") }) { Text(".") } }
            P { Text(if (firstRun) "First-run: create the owner account." else "Sign in to the Control Plane.") }

            TextField("Email", email, type = InputType.Email, placeholder = "you@rylcart.com") { email = it }
            TextField("Password", password, type = InputType.Password) { password = it }

            Div(attrs = { classes("row"); style { property("gap", "12px"); property("margin-top", "8px") } }) {
                PrimaryButton(if (firstRun) "Create account" else "Sign in", disabled = busy || email.isBlank() || password.isBlank()) {
                    busy = true
                    scope.launch {
                        val res = runCatching {
                            if (firstRun) app.api.register(email, password, null)
                            else app.api.login(email, password)
                        }
                        res.onSuccess {
                            app.setToken(it.token)
                            app.navigate(com.rylcart.cp.ui.state.Route.Tenants)
                        }
                        res.onFailure {
                            val msg = (it as? ApiException)?.message ?: it.message ?: "failed"
                            app.showError(msg)
                        }
                        busy = false
                    }
                }
                Div(attrs = { classes("spacer") }) {}
                // Only offer the first-run toggle while the server reports no
                // admin exists; once setup is done the link disappears.
                if (needsSetup == true) {
                    Span(attrs = {
                        classes("muted")
                        style { property("cursor", "pointer"); property("font-size", "13px") }
                        onClick { firstRun = !firstRun }
                    }) {
                        Text(if (firstRun) "Have an account? Sign in" else "First-run setup")
                    }
                }
            }
        }
    }
}
